import React from 'react';

const Loader = () => (
  <div className="press-custom-loader spinner spinner-md is-auth0">
    <div className="circle" />
  </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/pages/press/components/Loader/Loader.js